import { render, staticRenderFns } from "./PartnersPage.vue?vue&type=template&id=ff6adbd8&scoped=true"
import script from "./PartnersPage.vue?vue&type=script&lang=js"
export * from "./PartnersPage.vue?vue&type=script&lang=js"
import style0 from "./PartnersPage.vue?vue&type=style&index=0&id=ff6adbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6adbd8",
  null
  
)

export default component.exports